import PrizeBannerDisplay from './PrizeBannnerDisplay'

export default PrizeBannerDisplay;